import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import clock from "../../assets/images/clock.png";
import star from "../../assets/images/Star.png";
import { usePartner } from "../../context/PartnerContext";
import { DEFAULT_SESSION_FEE, getSessionFee } from "../../utils/pricing";

const SessionDetail = () => {
  const { config } = usePartner() || {};
  const { partnerSlug } = useParams();
  const [fee, setFee] = useState(DEFAULT_SESSION_FEE);

  useEffect(() => {
    setFee(getSessionFee({ partnerSlug, config }));
  }, [config, partnerSlug]);

  return (
    <div className="SessionsDetails">
      <div className="FeesStructure">
        <div className="FeeImageStructure">
          <span className="icon-text">{"\u20B9"}</span>
          <h1>{fee}</h1>
        </div>
        <p className="FeeText">Session Fees</p>
      </div>

      <div className="FeesStructure">
        <div className="FeeImageStructure">
          <img src={clock} alt="clock" className="icon-image" />
          <h1>40 mins</h1>
        </div>
        <p className="FeeText">Session Duration</p>
      </div>

      <div className="FeesStructure">
        <div className="FeeImageStructure">
          <img src={star} alt="star" className="icon-image" />
          <h1>4.9/5</h1>
        </div>
        <p className="FeeText">Star Rating</p>
      </div>
    </div>
  );
};

export default SessionDetail;
